module.exports = __webpack_public_path__ + "images/itas_header-0b6d9a53cd37a0199fb9fe6c0223b693.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/itas_header.jpg
// module id = 41
// module chunks = 0